import React, { useState, useRef } from "react";
import { Grid, Box, Typography, Button, TextField } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import RjfsForm from "./RjfsForm";

const ImportForm = () => {
  const [jsonSchema, setJsonSchema] = useState(null);
  const [jsonSchemaForm, setJsonSchemaForm] = useState({});

  const handleUpdateSchema = (newSchema) => {
    // console.log(newSchema);
    setJsonSchema(newSchema);
  };

  const convertMaxItemsAndFileRequired = (schema) => {
    if (typeof schema === "object") {
      for (const key in schema) {
        if (key === "maxItems") {
          try {
            schema[key] = parseInt(schema[key], 10);
          } catch (error) {
            console.warn(`Error converting maxItems for key: ${key}`, error);
          }
        } else if (key === "file_required") {
          schema[key] = schema[key] === "true" || schema[key] === true;
        } else {
          convertMaxItemsAndFileRequired(schema[key]);
        }
      }
    } else if (Array.isArray(schema)) {
      schema.forEach((item) => convertMaxItemsAndFileRequired(item));
    }
    return schema;
  };

  const handleUpdateFormSchema = () => {
    // setShowConsent(true);
    const json_form = JSON.parse(jsonSchema);
    console.log(json_form);
    const convertedJsonSchema = convertMaxItemsAndFileRequired(json_form);
    setJsonSchemaForm(convertedJsonSchema);
  };

  return (
    <Grid
      container
      spacing={2}
      style={{ padding: 100, marginLeft: 200, width: "90%" }}
    >
      <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          startIcon={<ArrowForwardIcon />}
          onClick={handleUpdateFormSchema}
        >
          Update Schema
        </Button>
      </Grid>
      <Grid item xs={6}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            height: "100vh", // Set full screen height
          }}
        >
          <Typography variant="h5" sx={{ mb: 2 }}>
            Enter JSON Schema
          </Typography>
          <textarea
            value={jsonSchema}
            onChange={(e) => handleUpdateSchema(e.target.value)}
            style={{
              width: "90%", // Half of screen width
              height: "85%", // Full height
              border: "1px solid lightgray",
              boxSizing: "border-box", // Ensure content fits within specified size
              fontFamily: "monospace", // Monospace font for code readability
              fontSize: "14px", // Adjust font size as needed
              padding: "10px", // Add padding for better user experience
            }}
          />
        </Box>
      </Grid>
      <Grid item xs={6}>
        <RjfsForm jsonSchemaForm={jsonSchemaForm} />
      </Grid>
    </Grid>
  );
};

export default ImportForm;
